import React from 'react';
import { Box } from '@mui/material';
import AdminCompanyEdit from './AdminCompanyEdit';
import AdminCompanyTracking from './AdminCompanyTracking';
import AdminCompanyPayments from './AdminCompanyPayments';
import AdminBotPanel from './AdminBotPanel';
import AdminHolidays from './AdminHolidays';
import AdminSystem from './AdminSystem';
import Reminders from './Reminders';
import AdminProjectTracking from './AdminProjectTracking';

function AdminContent({ content }) {
  return (
    <Box id="MainBody">
      {content === 0 && <AdminCompanyEdit />}
      {content === 1 && <AdminCompanyTracking />}
      {content === 2 && <AdminProjectTracking />}
      {content === 3 && <AdminCompanyPayments />}
      {content === 4 && <Reminders />}
      {content === 5 && <AdminBotPanel />}
      {content === 6 && <AdminHolidays />}
      {content === 7 && <AdminSystem />}
    </Box>
  );
}

export default AdminContent;
